import React from "react";
import styled, { createGlobalStyle } from "styled-components";

import * as ELD from "~/ELD";
import * as Layout from "~/Layout";
import { Time } from "~/Time";
import * as Typography from "~/Typography";

export const Component = () => (
  <Layout.Page.Component all>
    <Layout.Section.Component>
      <Headers.Component />
      <ELD.Table.Component />
    </Layout.Section.Component>
  </Layout.Page.Component>
);

namespace Headers {
  export const Component: Component = () => (
    <Container.Component all>
      <div>
        <ELD.Search.Component />
      </div>
      <div>
        <Title.Component />
      </div>
      <div>
        <Layout.Inline.Component right>
          <ELD.Interval.Component />
        </Layout.Inline.Component>
        <ELD.Download.Component />
      </div>
    </Container.Component>
  );

  // TODO: Standardize section headers
  namespace Container {
    export const Component = styled(Layout.Block.Component)`
      display: flex;

      & > div {
        display: flex;
        align-items: center;
        justify-content: center;
        flex: 1;

        &:first-child {
          justify-content: flex-start;
          margin-right: auto;
        }

        &:last-child {
          justify-content: flex-end;
          margin-left: auto;
        }
      }
    `;
  }
}

namespace Title {
  export const Component: Component = () => (
    <Typography.H1.Component>
      <Time.Interval
        Start={DateTime.Component}
        Stop={DateTime.Component}
        Separator={() => <> – </>}
        Duration={() => null}
        {...Time.Interval.when(ELD.useInterval(), {
          stopped: (stopped) => stopped,
          started: ({ interval: { start } }) => ({
            interval: { start, stop: Time.DateTime.now() },
          }),
        })}
      />
    </Typography.H1.Component>
  );

  namespace DateTime {
    export const Component = (dateTime: Time.DateTime) => (
      <Time.DateTime
        {...dateTime}
        Time={() => null}
        Separator={() => null}
        Date={(dateTime) => <>{Time.DateTime.toDateOnlyMMMDYYYY(dateTime)}</>}
      />
    );
  }
}

export namespace LegacyOverride {
  export const Component = createGlobalStyle`
    #view.elds {
      padding: 0;
    }
  `;
}
